import { isSiaAgent } from './agentAvatarWaveViewBody.js'
import { hashSeed } from './hashSeed.js'
import { hsl } from './hsl.js'

export function getAgentAvatarWave(seed, agentId, name) {
  const raw = String(seed ?? '').trim().toLowerCase() || 'agent'
  const h = hashSeed(raw)

  if (isSiaAgent(agentId, name, raw)) {
    const tealHue = 174
    return {
      colorB: hsl(tealHue + 28, 22, 84),
      colorC: hsl(tealHue - 18, 18, 88),
      angle: h % 360,
      spinDuration: 8 + (h % 7),
    }
  }

  const hue = h % 360
  const colorB = hsl(hue + 120, 18 + (h % 10), 84 + (h % 10))
  const colorC = hsl(hue + 240, 12 + (h % 8), 88 + (h % 8))

  return {
    colorB,
    colorC,
    angle: h % 360,
    spinDuration: 8 + (h % 7),
  }
}

/**
 * @param {string} [agentId]
 * @param {string} [name]
 */

export function getAgentAvatarSeed(agentId, name) {
  const id = String(agentId ?? '').trim()
  if (id) return id
  return String(name ?? '').trim().toLowerCase() || 'agent'
}
